import { Stack } from "@mui/material";
import React from "react";
import { SeasonBreakBanner } from "components/SeasonBreakBanner";

type PageProps = {
  children: React.ReactNode;
};

export const Page = ({ children }: PageProps) => (
  <Stack height="100%" maxHeight="100%" overflow="hidden">
    <SeasonBreakBanner />
    {children}
  </Stack>
);
